// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getDatabase } from "firebase/database";


/*const firebaseConfig = {
  apiKey: "AIzaSyCfzhJ9Ur1HuF9Kcz_f1nPa-jxHAi1OaFM",
  authDomain: "rorolive.firebaseapp.com",
  databaseURL: "https://rorolive-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "rorolive",
  storageBucket: "rorolive.firebasestorage.app",
  messagingSenderId: "520008645017",
  appId: "1:520008645017:web:900f71be38185377d23b08",
  measurementId: "G-CVL3B1GCRY"
};*/
const firebaseConfig = {
  apiKey: "AIzaSyA_ZjR_1HOtBZuFlc852Bh4_SyRVEocLYs",
  authDomain: "roro-7d0cb.firebaseapp.com",
  databaseURL: "https://roro-7d0cb-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "roro-7d0cb",
  storageBucket: "roro-7d0cb.firebasestorage.app",
  messagingSenderId: "82830475450",
  appId: "1:82830475450:web:5562903bb6854e45650283",
  measurementId: "G-P2HDPCGSSN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db  = getDatabase(app);
